module.exports = __webpack_public_path__ + "static/img/jjfa_ny.cdd78356.png";